@if (isVisible$ | async) {
  <rask-toggle-panel label="Justera kontraktutskrift"
    [defaultExpanded]="false"
    [validationIcon]="getIcon()"
    (onToggle)="toggle($event)">
    @if (!kontrakt?.isAnySkogsvard) {
      <rask-kontrakt-justera-utskrift>
      </rask-kontrakt-justera-utskrift>
    }
    <div class="mb-3">
      @if (isSkogsvardVisible$ | async) {
        <rask-kontrakt-anteckningskogsvard
          label="Övrig anteckning för skogsvård">
        </rask-kontrakt-anteckningskogsvard>
      }
    </div>
  </rask-toggle-panel>
}